import { useEffect } from "react"
import { Outlet, useSearchParams } from "react-router"
import { useMount } from "react-use"
import { useAtomValue } from "jotai"

import { useAgentState } from "@/agent-state"
import { useFetchAgentProfile } from "@/agent-state/use-fetch-agent-profile"
import ConnectCCP from "@/components/core/ConnectCCP"
import Loader from "@/components/layout/Loader"
import { PageLayout } from "@/components/layout/page-layout"
import { ccpModeAtom } from "@/helpers/atoms"
import { getIframeContainer } from "@/helpers/ccp"
import { useUnfinishedManualCallChecker } from "@/hooks/useUnfinishedManualCallChecker"
import ErrorPage from "@/pages/ErrorPage"
import { useFetchRoutingProfiles } from "@/pages/Users/users-api"

export function AppShell() {
  const { send } = useAgentState()
  const { data } = useFetchAgentProfile()
  // Fetch and cache the routing profiles to display in the edit profile modal.
  useFetchRoutingProfiles()

  const agentProfile = data?.data || null
  const ccpMode = useAtomValue(ccpModeAtom)
  useUnfinishedManualCallChecker()
  useIframeDebugMode()

  useEffect(() => {
    if (agentProfile?.id) {
      send({ type: "AGENT_PROFILE_LOADED", agentProfile })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agentProfile?.id])

  return (
    <PageLayout agentProfile={agentProfile}>
      {ccpMode.current === "LOADING" && <Loader isSlow={ccpMode.isSlow} />}
      {ccpMode.current === "INITIALIZED" && <Outlet />}
      {/* If the CCP panel fails to initialize properly (oauth error, exceeded the number of retries, etc.) */}
      {ccpMode.current === "ERROR" && <ErrorPage />}
      <ConnectCCP />
    </PageLayout>
  )
}

function useIframeDebugMode() {
  const [params] = useSearchParams()

  useMount(() => {
    const showIframe = params.has("debug")
    const container = getIframeContainer()
    if (showIframe) {
      container.style.display = "block"
    } else {
      container.style.display = "none"
    }
  })
}
